export const ru = {
  'bank.mode': 'Способ расчёта',
  'bank.monthly': 'Стандартный — ставка / 12 каждый месяц',
  'bank.calendar': 'Банковский график — по календарным дням',
  'bank.explanation': 'Проценты за фактические дни с учётом 365/366 дней в году. Аннуитетный платёж не меньше процентов за 31 день, первый — ещё и не меньше процентов за первый период.',
  'bank.disbursement': 'Дата выдачи / предыдущего платежа',
  'bank.paymentDay': 'День обязательного платежа',
  'bank.recalculate': 'Плановые пересчёты платежа',
  'bank.recalculateHint': 'Если банк пересчитывает платёж по графику, укажите месяц первого платежа с новой суммой. Новый платёж считается по текущему остатку, той же ставке и оставшемуся сроку. Пусто — без пересчёта.',
  'bank.recalculateMonth': 'Месяц нового платежа',
  'bank.recalculateAdd': '+ Ещё пересчёт',
  'bank.recalculateRemove': 'Удалить пересчёт',
  'bank.overpaymentHint': 'Досрочки учитываются в день обязательного платежа после его списания. Уменьшение платежа действует со следующего месяца; сокращение срока сохраняет текущий платёж. Платежи между датами списания здесь не моделируются.',
  'bank.modeError': 'Выберите способ расчёта.',
  'bank.error': 'Для календарного расчёта укажите дату выдачи раньше первого платежа и день списания от 1 до 31. Месяц пересчёта — после первого платежа и внутри срока кредита.',
  'bank.log': 'Календарный расчёт: день платежа {day}; досрочки после обязательного платежа в этот же день.',
  'summary.totalInterest': 'Общая сумма процентов',
  'summary.totalPaid': 'Общая сумма выплат',
  'summary.actualTerm': 'Фактический срок',
  'summary.maxMonthlyPayment': 'Макс. ежемесячный платёж',
  'summary.payoffDate': 'Дата полного погашения',
  'actions.save': 'Сохранить',
  'actions.share': 'Поделиться расчётом',
};

